import { use } from 'react'

import { UiContext } from './Context'

export const useSnackbar = () => {
  const { showSnackbar } = use(UiContext)

  return showSnackbar
}
